import { Box, Text, HStack, IconButton, Spinner } from '@chakra-ui/react';

import { MessageAttachment } from '@/features/messages/messages.types';
import { FiDownload } from 'react-icons/fi';
import { getAttachmentBgColor } from './conversation-utils';

export const MessageAttachmentVideo = ({
  isUser,
  isAIAgent,
  messageStatus,
  attachment,
}: {
  isUser: boolean;
  isAIAgent: boolean;
  messageStatus: string;
  attachment: MessageAttachment;
}) => {
  if (!attachment) {
    return null;
  }

  return (
    <Box
      borderRadius="md"
      overflow="hidden"
      width="100%"
      maxWidth="300px"
      bg={getAttachmentBgColor(isUser, isAIAgent)}
      position="relative"
      opacity={
        messageStatus === 'pending' || messageStatus === 'sending' ? 0.8 : 1
      }
    >
      {/* Add loading indicator for pending and sending states */}
      {(messageStatus === 'pending' || messageStatus === 'sending') && (
        <Spinner
          size="sm"
          position="absolute"
          top="3px"
          right="3px"
          color="white"
          zIndex="1"
        />
      )}

      <Box
        width="100%"
        height="180px"
        bg="gray.100"
        overflow="hidden"
        position="relative"
      >
        <video
          src={attachment.file_url}
          controls
          width="100%"
          height="100%"
          style={{
            objectFit: 'cover',
            backgroundColor: 'black',
          }}
        />
      </Box>

      <Box p={2}>
        <Text fontSize="sm" fontWeight="medium" color="white">
          {attachment.file_name || 'Video message'}
        </Text>
      </Box>

      <HStack
        position="absolute"
        top="2"
        right="2"
        gap={1}
        opacity="0.8"
        transition="opacity 0.2s"
        _groupHover={{ opacity: 1 }}
        as="div"
        role="group"
      >
        <IconButton
          aria-label="Download video"
          size="xs"
          colorPalette={isUser ? 'gray' : isAIAgent ? 'green' : 'blue'}
          variant="solid"
          onClick={(e) => {
            e.stopPropagation();
            window.open(attachment.file_url, '_blank');
          }}
          borderRadius="full"
        >
          <FiDownload />
        </IconButton>
      </HStack>
    </Box>
  );
};
